import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectEntitlementProductDocumentResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_PRODUCT_DOCUMENT_RESP);
        this.documents = [];
    }
    GetDocuments() {
        return this.documents;
    }
    AddDocument(document) {
        this.documents.push(document);
    }
}
